export { historyWatch };
const historyWatch = () => {
  return [
    {
      label: 'History - Watch',
      icon: 'dashboard',
      view: {
        type: 'table',
        content: [
          {
            header: 'Asset',
            field: 'assetName',
            width: 'max',
          },
          {
            header: 'Time',
            field: 'time',
            width: 'max',
          },
          {
            header: 'Speed',
            field: 'speed',
            visible: false
          },
          {
            header: 'Battery',
            field: 'batt',
          },
          {
            header: 'BP',
            field: 'bp',
            visible: true
          },
          {
            header: 'SPO2',
            field: 'spO2',
            visible: true
          },
          {
            header: 'HR',
            field: 'heartRate',
          },
          {
            header: 'Steps',
            field: 'steps',
            visible: true
          },
          {
            header: 'Idle',
            field: 'idling',
            //   template: {
            //     component: 'IconButtons',
            //     data: {
            //       idle: ` <svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 24 24">
            //   <path
            //     fill="currentColor"
            //     d="M23 12h-6v-2l3.39-4H17V4h6v2l-3.38 4H23v2m-8 4H9v-2l3.39-4H9V8h6v2l-3.38 4H15v2m-8 4H1v-2l3.39-4H1v-2h6v2l-3.38 4H7v2Z"
            //   />
            // </svg>`,
            //       moving: `<svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 30 30"><path fill="currentColor" d="M4 16h12v2H4zm-2-5h10v2H2z"/><path fill="currentColor" d="m29.919 16.606l-3-7A.999.999 0 0 0 26 9h-3V7a1 1 0 0 0-1-1H6v2h15v12.556A3.992 3.992 0 0 0 19.142 23h-6.284a4 4 0 1 0 0 2h6.284a3.98 3.98 0 0 0 7.716 0H29a1 1 0 0 0 1-1v-7a.997.997 0 0 0-.081-.394ZM9 26a2 2 0 1 1 2-2a2.002 2.002 0 0 1-2 2Zm14-15h2.34l2.144 5H23Zm0 15a2 2 0 1 1 2-2a2.002 2.002 0 0 1-2 2Zm5-3h-1.142A3.995 3.995 0 0 0 23 20v-2h5Z"/></svg>`,
            //     },
            //   },
            // textAlign: 'Center',
          },
          {
            header: 'Location',
            field: 'address',
          },
          {
            header: 'POI Type',
            field: 'poiType',
          },
          {
            header: 'POI Duration',
            field: 'poiTime',
          },
          {
            header: 'Beacon',
            field: 'beacon',
          },
          {
            header: 'Coords',
            field: 'coordinates',
            template: {
              component: 'GoogleMapLink',
            },
          },
          {
            header: 'GPS',
            field: 'gps',
            visible: false
          },
          // {
          //   header: 'Actions',
          //   template: {
          //     component: 'ActionButtons',
          //     data: [
          //       {
          //         text: 'View Trip Playback',
          //         icon: 'icon-map',
          //         iconPack: 'feather',
          //         // click: {
          //         //   component: 'PlayBack',
          //         //   data: { onReady: getPlayback },
          //         // },
          //       },
          //     ],
          //   },
          // },
        ],
      },
      pdf: {
        title: 'History - Watch',
        colsWidth: [71, 103, 40, 49, 31, 46, 37, 60, 60, 60, 38, 37],
      },
    },
  ];
};
